




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import DashboardAppBar from './components/core/AppBar.vue';
import DashboardDrawer from './components/core/Drawer.vue';
import DashboardView from './components/core/View.vue';

@Component({
  components: {
    DashboardAppBar,
    DashboardDrawer,
    DashboardView,
  },
})
export default class DashboardIndex extends Vue {
  expandOnHover = false;
}
